import React, { useState, useEffect } from "react";
import {
  Modal, Box, Button, TextField, Select, MenuItem,
  Grid, Card, CardMedia, Typography, Snackbar, Alert,
  CircularProgress, IconButton,
  Stack,
  Backdrop,
  Paper,
  Divider
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { db } from "../../firebase";
import {
  collection, addDoc, getDocs, onSnapshot, query, where,
  getCountFromServer,
  getDoc,
  doc
} from "firebase/firestore";

// ==================== Modal Styling ====================
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};

function Createpost() {

  // ==================== States ====================
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("image");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");

  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  // Replace const [sending, setSending] = useState(false);
  const [sendingId, setSendingId] = useState(null);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  // Add this state at the top with your other states
  const [divisionCounts, setDivisionCounts] = useState({});

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "bdivisions"), async (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().division,
      }));
      setDivisions(list);
      try {
        const counts = {};

        await Promise.all(list.map(async (div) => {
          const q = query(collection(db, "contacts"), where("divisionId", "==", div.id));
          const snap = await getCountFromServer(q);
          counts[div.id] = snap.data().count;
        }));

        const allSnap = await getCountFromServer(collection(db, "contacts"));
        counts["all"] = allSnap.data().count;

        setDivisionCounts(counts);
      } catch (err) {
        console.error("Error fetching counts:", err);
      }

      setLoading(false);
    });

    return () => unsub();
  }, []);

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // ==================== Fetch Divisions ====================
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "bdivisions"), (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().division,
      }));
      setDivisions(list);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  // ==================== Fetch Posts PHP API ====================
  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://whatsapp.mmischoolkm.com/fetch_posts.php");
      const data = await res.json();
      setPosts(data);
    } catch (err) {
      showToast("Failed to load posts", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // ==================== Helper Toast Function ====================
  const showToast = (msg, severity = "success") =>
    setToast({ open: true, message: msg, severity });

  // ==================== File Change ====================
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
  };

  // ==================== Save Post ====================
  const handleSubmit = async () => {
    if (!file || !title) return showToast("Add title & select file", "warning");

    setSending(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("type", type);
    formData.append("file", file);

    try {
      const res = await fetch("https://whatsapp.mmischoolkm.com/save_post.php", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();
      if (result.status === "success") {
        showToast("Post uploaded successfully");
        resetForm();
        fetchPosts();
      } else {
        showToast(result.message, "error");
      }
    } catch {
      showToast("Upload failed", "error");
    }

    setSending(false);
  };

  const resetForm = () => {
    setOpen(false);
    setTitle("");
    setFile(null);
    setPreview("");
  };

  // ==================== Delete Post ====================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this post?")) return;

    await fetch("https://whatsapp.mmischoolkm.com/delete_post.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    fetchPosts();
  };

  // Helper to split array into chunks
  const chunkArray = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );

  const handleSendWhatsApp = async (post) => {
    if (!division) return showToast("Select division first!", "warning");
    if (!window.confirm(`Send ultra-fast campaign to division contacts?`)) return;

    const wabaid = "895670676961935";
    const accesstoken = "EAALntLdtw0QBPyM26necVXVlinICAL33CUN3zxsAHCmSvns6cYOD2SILLkdsMZBRDMjs6FFbybZCulrZC8bptKF6duET3yArXiW560ZCQxFTtPEIBWC7Oq4LSWMwBzHkJxjPsnUF6iNatFZCsC4J3eZCHmhIICLZB32JCN19sIcxR8hlSK7dNMwnZBAxrWTFyAZDZD";

    setSending(true);
    setProgress({ current: 0, total: 0 });

    try {
      // 1. Fetch Contacts
      let snapshot;
      if (division === "all") {
        snapshot = await getDocs(collection(db, "contacts"));
      } else {
        snapshot = await getDocs(query(collection(db, "contacts"), where("divisionId", "==", division)));
      }

      const allContacts = snapshot.docs
        .map((doc) => doc.data())
        .filter((c) => c.whatsapp && /^\d{10}$/.test(c.whatsapp.trim()));

      if (!allContacts.length) {
        showToast("No contacts found!", "warning");
        setSending(false);
        return;
      }

      setProgress({ current: 0, total: allContacts.length });

      const batches = chunkArray(allContacts, 10);
      let successCount = 0;

      for (const batch of batches) {
        // Execute the entire batch at the SAME TIME
        await Promise.all(batch.map(async (c) => {
          let status = "failed";
          const payload = {
            messaging_product: "whatsapp",
            to: `91${c.whatsapp}`,
            type: "template",
            template: {
              name:
                post.type === "image"
                  ? "mmis_img"
                  : post.type === "video"
                    ? "mmis_video"
                    : "mmis_doc", // ✅ NEW TEMPLATE

              language: { code: "en" },
              components: [
                {
                  type: "header",
                  parameters: [
                    post.type === "image"
                      ? { type: "image", image: { link: post.image } }
                      : post.type === "video"
                        ? { type: "video", video: { link: post.image } }
                        : {
                          type: "document",
                          document: {
                            link: post.image,
                            filename: post.title || "Document.pdf",
                          },
                        },
                  ],
                },
              ],
            },
          };

          try {
            const r = await fetch(`https://graph.facebook.com/v22.0/${wabaid}/messages`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
              },
              body: JSON.stringify(payload),
            });
            const res = await r.json();
            if (res.messages?.[0]?.id) {
              status = "sent";
              successCount++;
            }
          } catch (e) {
            status = "failed";
          }

          // Save to Firebase History
          await addDoc(collection(db, "whatsapphistory"), {
            mobile: c.whatsapp,
            division,
            postTitle: post.title,
            status: status,
            timestamp: new Date().toISOString(),
          });

          // Update progress count
          setProgress(prev => ({ ...prev, current: prev.current + 1 }));
        }));

        // Small delay between batches to stay under rate limits (e.g., 200ms)
        await new Promise(res => setTimeout(res, 500));
      }

      showToast(`Completed! Successfully sent to ${successCount} contacts.`);
    } catch (err) {
      console.error(err);
      showToast("Critical failure during sending", "error");
    } finally {
      setSending(false);
    }
  };

  // const triggerCampaign = async (post) => {
  //   if (!division) return showToast("Select division first!", "warning");

  //   try {
  //     await fetch(
  //       "https://asia-south1-whatsapp-mmis.cloudfunctions.net/sendWhatsappCampaign",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           postId: post.id,
  //           postTitle: post.title,
  //           postType: post.type,
  //           postMedia: post.image,
  //           division,
  //         }),
  //       }
  //     );

  //     showToast("Campaign started in background 🚀");
  //   } catch {
  //     showToast("Failed to start campaign", "error");
  //   }
  // };


  const triggerCampaign = async (post) => {
    if (!division) return showToast("Select division first!", "warning");
    if (!window.confirm(`Start background campaign for ${post.title}?`)) return;

    setSendingId(post.id); // Show loading spinner on the specific card

    try {
      // 1. Fetch contacts locally first (to pass them to the server)
      let snapshot;
      if (division === "all") {
        snapshot = await getDocs(collection(db, "contacts"));
      } else {
        const q = query(collection(db, "contacts"), where("divisionId", "==", division));
        snapshot = await getDocs(q);
      }

      const contactList = snapshot.docs
        .map((doc) => doc.data())
        .filter((c) => c.whatsapp && /^\d{10}$/.test(c.whatsapp.trim()));

      if (contactList.length === 0) {
        setSendingId(null);
        return showToast("No valid contacts found in this division", "warning");
      }

      const response = await fetch("http://localhost:5000/send-campaign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          postTitle: post.title,
          postType: post.type,
          postMedia: post.image,
          wabaid: "895670676961935",
          accessToken: "EAALntLdtw0QBPyM26necVXVlinICAL33CUN3zxsAHCmSvns6cYOD2SILLkdsMZBRDMjs6FFbybZCulrZC8bptKF6duET3yArXiW560ZCQxFTtPEIBWC7Oq4LSWMwBzHkJxjPsnUF6iNatFZCsC4J3eZCHmhIICLZB32JCN19sIcxR8hlSK7dNMwnZBAxrWTFyAZDZD",
          contacts: contactList // Sending the filtered list to Node.js
        }),
      });

      if (response.ok) {
        showToast("Campaign started in background! 🚀");
      } else {
        const errorData = await response.json();
        showToast(errorData.message || "Server refused the campaign", "error");
      }
    } catch (err) {
      console.error("Connection Error:", err);
      showToast("Failed to connect to the Node.js server", "error");
    } finally {
      setSendingId(null); // Stop loading animation
    }
  };

  // ==================== UI ====================
  return (
    <Box p={1}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 800,
            color: "#1e293b",
            letterSpacing: '-0.5px',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          WhatsApp Campaign <span style={{ fontSize: '1.2rem' }}>📢</span>
        </Typography>

        <Button
          variant="contained"
          size="small" // Makes button small
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
          sx={{
            bgcolor: "blueteal",
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 'bold',
            px: 2,
            '&:hover': { bgcolor: '#054d44' }
          }}
        >
          Create Campaign
        </Button>
      </Stack>

      {/* ==================== Posts List ==================== */}
      {loading ? (
        <Box textAlign="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid className="row" spacing={2} mt={1}>
          {posts.map((post) => (
            <Grid className="col-sm-2 mb-3" key={post.id}>
              <Card>
                <CardMedia
                  component={post.type === "image" ? "img" : "video"}
                  src={post.image}
                  controls={post.type === "video"}
                  sx={{ height: 150, objectFit: "cover" }}
                />

                <Box p={2}>
                  <Select
                    fullWidth
                    size="small"
                    value={division}
                    onChange={(e) => setDivision(e.target.value)}
                    displayEmpty
                    sx={{ mt: 1, mb: 1 }}
                  >
                    <MenuItem value="">
                      <em>Select Division</em>
                    </MenuItem>

                    {divisions.map((d) => (
                      <MenuItem key={d.id} value={d.id}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                          <Typography variant="body2">{d.name}</Typography>
                          <Typography
                            variant="caption"
                            sx={{ bgcolor: "#f1f5f9", px: 1, borderRadius: 1, fontWeight: "bold", color: "text.secondary", ml: 2 }}
                          >
                            {divisionCounts[d.id] || 0}
                          </Typography>
                        </Box>
                      </MenuItem>
                    ))}

                    <MenuItem value="all">
                      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                        <Typography variant="body2">⭐ All Contacts</Typography>
                        <Typography
                          variant="caption"
                          sx={{ bgcolor: "#e0f2fe", px: 1, borderRadius: 1, fontWeight: "bold", color: "#0369a1", ml: 2 }}
                        >
                          {divisionCounts["all"] || 0}
                        </Typography>
                      </Box>
                    </MenuItem>
                  </Select>

                  <Box display="flex" justifyContent="space-between">
                    <IconButton color="success" onClick={() => handleSendWhatsApp(post)}>
                      {sendingId === post.id ? <CircularProgress size={22} /> : <WhatsAppIcon />}
                    </IconButton>

                    <IconButton color="error" onClick={() => handleDelete(post.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* ==================== Add Post Modal ==================== */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" mb={2}>Add Campaign</Typography>

          <Select
            fullWidth
            value={type}
            onChange={(e) => setType(e.target.value)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="image">Image</MenuItem>
            <MenuItem value="video">Video</MenuItem>
            <MenuItem value="document">Document</MenuItem> {/* ✅ NEW */}

          </Select>

          <TextField
            fullWidth
            label="Campaign Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 2 }}
          />

          <input type="file" accept={`${type}/*`} onChange={handleFileChange} />

          {preview && (
            <Card sx={{ mt: 2 }}>
              {type === "image" && <CardMedia component="img" height="200" src={preview} />}
              {type === "video" && <CardMedia component="video" height="200" src={preview} controls />}
              {type === "document" && (
                <Typography p={2}>📄 Document Selected</Typography>
              )}
            </Card>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            disabled={sending}
            onClick={handleSubmit}
          >
            {sending ? <CircularProgress size={22} /> : "Save Campaign"}
          </Button>
        </Box>
      </Modal>

      {/* ==================== Toast ==================== */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
      >
        <Alert severity={toast.severity} variant="filled" sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, flexDirection: 'column' }}
        open={sending}
      >
        <Paper sx={{ p: 4, borderRadius: 4, textAlign: 'center', minWidth: 300 }}>
          <CircularProgress color="success" size={60} thickness={4} />

          <Typography variant="h6" fontWeight="bold" mt={2} color="text.primary">
            Sending Campaign...
          </Typography>

          <Stack direction="row" spacing={3} justifyContent="center" mt={2}>
            <Box>
              <Typography variant="h4" fontWeight="800" color="primary">{progress.total}</Typography>
              <Typography variant="caption" color="text.secondary">TOTAL</Typography>
            </Box>

            <Divider orientation="vertical" flexItem />

            <Box>
              <Typography variant="h4" fontWeight="800" color="success.main">{progress.current}</Typography>
              <Typography variant="caption" color="text.secondary">SENT</Typography>
            </Box>

            <Divider orientation="vertical" flexItem />

            <Box>
              <Typography variant="h4" fontWeight="800" color="warning.main">
                {progress.total - progress.current}
              </Typography>
              <Typography variant="caption" color="text.secondary">REMAINING</Typography>
            </Box>
          </Stack>

          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', fontStyle: 'italic' }}>
            Please do not close this window until process starts...
          </Typography>
        </Paper>
      </Backdrop>
    </Box>
  );
}

export default Createpost;
